"use client";

import React from "react";

//Types
import { DropdownComponentProps } from "@/types";

//Styles
import * as S from "./styles";

//Icon
import icons from "@/assets/svg";

function isIconName(icon: any): icon is keyof typeof icons {
  return typeof icon === "string" && icon in icons;
}

const DropdwonComponent: React.FC<DropdownComponentProps> = ({
  titleButton,
  titleDropdown,
  items,
  children,
  icon,
}) => {
  return (
    <S.DropdownBox>
      <S.DropdownButton>
        {isIconName(icon) ? <S.IconComponent name={icon} /> : icon}
        {titleButton}
      </S.DropdownButton>
      <S.Dropdown>
        {children ? (
          <>
            {titleDropdown && (
              <S.DropdownTitle>{titleDropdown}</S.DropdownTitle>
            )}
            <S.DropdownContent>{children}</S.DropdownContent>
          </>
        ) : (
          <>
            {titleDropdown && (
              <S.DropdownTitle>{titleDropdown}</S.DropdownTitle>
            )}
            <S.DropdownContent>
              {items &&
                items.map((item, idx) => (
                  <S.DropdownItem key={idx}>
                    {item.link ? (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        {item.icon}
                        {item.label}
                      </a>
                    ) : (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        {item.icon}
                        {item.label}
                      </span>
                    )}
                  </S.DropdownItem>
                ))}
            </S.DropdownContent>
          </>
        )}
      </S.Dropdown>
    </S.DropdownBox>
  );
};

export default DropdwonComponent;
